import classNames from "classnames";
import styles from "./customiser.module.css";
import { FlexRow } from "components-shared/Layout";
import Gutter from "ui-kit/Gutter";
import { Typography } from "ui-kit/Typography";
import { formatCurrency, formatSignedCurrency, isDefined } from "utils/utils";
import Colors from "ui-kit/colors";
import { FlexCol } from "ui-kit/Layout/Flex";
import { ReactElement } from "react";
import { Badge } from "ui-kit";

type Props = {
  option: {
    value?: number;
    title: string;
    subTitle?: string;
    totalDiff?: number;
    totalDiffTitle?: string;
    disabled?: boolean;
    disabledMessage?: string;
  };
  onChange: (value: number) => void;
  disabled?: boolean;
  isActive?: boolean;
  noBadge?: boolean;
  showSigned?: boolean;
  slim?: boolean;
  details?: ReactElement | null;
  name: string;
};

export const Option = ({
  option,
  onChange,
  disabled,
  isActive,
  noBadge,
  showSigned = false,
  slim,
  details,
  name,
}: Props) => {
  return (
    <>
      <label
        className={classNames(
          styles.option,
          (disabled || option.disabled) && styles.optionDisabled,
          isActive && styles.active,
          slim && styles.slim
        )}
        style={{ flex: 1 }}
      >
        <input
          aria-disabled={disabled || option.disabled}
          type="radio"
          name={name}
          onChange={() => onChange(option.value as number)}
          disabled={disabled || option.disabled}
          checked={isActive}
          className={classNames(styles.input, slim && styles.inputSlim)}
        />
        <FlexCol style={{ flex: 1 }}>
          <FlexRow alignItems="center" style={{ flex: 1 }}>
            <FlexCol>
              {slim ? (
                <Typography
                  color={disabled || option.disabled ? "grey500" : "black"}
                  className={styles.optionText}
                  align="center"
                >
                  {option.title}
                </Typography>
              ) : (
                <Typography
                  color={disabled || option.disabled ? "grey500" : "black"}
                  className={styles.optionText}
                  align="left"
                  style={{
                    ...(option.subTitle
                      ? {
                          lineHeight: 1,
                        }
                      : {}),
                  }}
                >
                  <strong>{option.title}</strong>
                </Typography>
              )}
              {option.disabled && option.disabledMessage ? (
                <Typography
                  color="grey500"
                  variant="body4"
                  style={{ lineHeight: 1, marginTop: 4 }}
                >
                  {option.disabledMessage}
                </Typography>
              ) : (
                option.subTitle && (
                  <Typography
                    color={disabled || option.disabled ? "grey500" : "grey500"}
                    className={styles.optionText}
                    align="left"
                    variant="body4"
                    style={{ lineHeight: 1, marginTop: 4 }}
                  >
                    {option.subTitle}
                  </Typography>
                )
              )}
            </FlexCol>
            {isDefined(option.totalDiff) &&
              !(option.disabled && option.disabledMessage) && (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-end",
                  }}
                >
                  <>
                    <Gutter size={1} horizontal />
                    <Typography
                      variant={noBadge ? "body2" : "body4"}
                      className={classNames(styles.badge)}
                      color={noBadge ? "blue300" : "grey500"}
                      style={
                        noBadge
                          ? {
                              background: "transparent",
                              ...(option.totalDiffTitle
                                ? { lineHeight: 1, padding: 0 }
                                : {}),
                            }
                          : {
                              backgroundColor:
                                option.totalDiff > 0
                                  ? Colors.sun200
                                  : Colors.forrest100,
                            }
                      }
                    >
                      <strong>
                        {showSigned
                          ? formatSignedCurrency(option.totalDiff)
                          : formatCurrency(option.totalDiff)}
                      </strong>
                    </Typography>
                    {option.totalDiffTitle && (
                      <Typography
                        variant="body4"
                        color="grey500"
                        style={{
                          textWrap: "nowrap",
                          lineHeight: 1,
                          marginTop: 4,
                        }}
                      ></Typography>
                    )}
                  </>
                </div>
              )}
          </FlexRow>
          {isActive && details ? details : null}
        </FlexCol>
      </label>
    </>
  );
};
